<template>
  <b-input
    v-model="form.name"
    :error-messages="getErrorMessages(v$.name)"
    label="Назва"
    placeholder="Введіть назву"
    @blur="v$.name.$touch()" />
  <b-input v-model="form.description" label="Опис" placeholder="Введіть опис" />
  <v-checkbox v-model="form.isActive" hide-details label="Активна" />
</template>
<script>
import { reactive } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import { setSnackbar } from 'best-modules/plugins'
import { createOrganization, updateOrganization } from '@/requests/organization'

export default {
  name: 'Organization',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  setup(props) {
    const isUpdate = props.dialog.action === 'update'
    const itemData = props.dialog.dialogData?.itemData

    const form = reactive({
      name: itemData?.name || null,
      description: itemData?.description || null,
      isActive: itemData?.isActive !== undefined ? itemData.isActive : true,
    })

    const v$ = useVuelidate({ name: { required } }, form)

    const submit = () => {
      const request = isUpdate
        ? updateOrganization(itemData.id, form)
        : createOrganization(form)

      return request.then(res => {
        setSnackbar({
          text: `Організацію ${isUpdate ? 'оновлено' : 'створено'}`,
        })
        return res
      })
    }

    return { form, v$, submit }
  },
}
</script>
